import { render, staticRenderFns } from "./FairCrash.vue?vue&type=template&id=64f1be5c&scoped=true"
import script from "./FairCrash.vue?vue&type=script&lang=js"
export * from "./FairCrash.vue?vue&type=script&lang=js"
import style0 from "./FairCrash.vue?vue&type=style&index=0&id=64f1be5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f1be5c",
  null
  
)

export default component.exports